import React from 'react';
import { BadgeCheck } from 'lucide-react';

export const TrustedBadge = ({ label = 'Stock wallet active', small = false, testid = 'trusted-user-badge' }) => (
    <span className={`inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 font-medium ${small ? 'px-1.5 py-0 text-[10px]' : 'px-2.5 py-0.5 text-xs'}`} data-testid={testid}>
        <BadgeCheck className={small ? 'h-3 w-3' : 'h-3.5 w-3.5'} /> {label}
    </span>
);
